import React from 'react'
import pageNotFound from '../src/images/pageNotFound.png'

const PageNotFound = () => {
  return (
    <div className='h-[100svh] flex items-center justify-center'>
      
        <img src={ pageNotFound } alt="" />
    </div>
  )
}

export default PageNotFound